import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { accountSetupStatus } from "../api/User.js";
import { AUTH_TOKEN } from "../redux/constants/Auth.js";

const OnboardingRedirectWrapper = ({ isOnboardingComplete }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [onboardingStatus, setOnboardingStatus] = useState(isOnboardingComplete);

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      const authToken = localStorage.getItem(AUTH_TOKEN);
      const onboardingInProgress = sessionStorage.getItem('onboarding_in_progress');
      
      if (onboardingInProgress) {
        setIsLoading(false);
        return;
      }

      if (!authToken) {
        setOnboardingStatus(false);
        setIsLoading(false);
        return;
      }

      try {
        const response = await accountSetupStatus();
        const isComplete = response.status === 200;
        setOnboardingStatus(isComplete);
        localStorage.setItem('onboardingComplete', isComplete.toString());
      } catch (error) {
        console.error("Error checking onboarding status:", error);
        setOnboardingStatus(false);
        localStorage.setItem('onboardingComplete', 'false');
      } finally {
        setIsLoading(false);
      }
    };

    checkOnboardingStatus();
  }, [location.pathname]);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (sessionStorage.getItem('onboarding_in_progress')) {
    return <Outlet />;
  }

  if (!onboardingStatus && !location.pathname.startsWith('/onboarding')) {
    return <Navigate to="/onboarding/welcome" replace />;
  }

  if (onboardingStatus && location.pathname.startsWith('/onboarding')) {
    return <Navigate to="/landing-page" replace />;
  }

  return <Outlet />;
};

export default OnboardingRedirectWrapper;